import { getUnixTime } from 'date-fns';
import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { FbmResource } from './_types';
import { normalizeFbmResource } from './normalizers';

export const fetchFbmResources = async ({
  page = 1,
  perPage = 20,
  sort,
  sortDir,
  filters,
  search,
  fetchAll = false,
}) => {
  const params = {
    page: fetchAll ? null : page,
    per: fetchAll ? null : perPage,
    fetch_all: fetchAll ? true : null,
    location_id: filters.locationId ? filters.locationId : null,
    start_time: filters.startTime ? getUnixTime(filters.startTime) : null,
    end_time: filters.endTime ? getUnixTime(filters.endTime) : null,
    available: filters.available ? filters.available : null,
    service_id: filters.serviceId ? filters.serviceId : null,
    q: {
      s: sort && sortDir ? `${sort} ${sortDir}` : null,
      name_or_description_cont: search || null,
      parent_id_eq: filters.parent ? filters.parent : null,
      parent_id_null: filters.is_parent ? true : null,
      parent_id_not_null: filters.is_child ? true : null,
    },
  };

  const response = await api.get(`/api/v4/fbm/resources`, {
    params: params,
  });

  const fbmResources = (response.data.resource || response.data)?.map((r) =>
    normalizeFbmResource(r)
  );

  if (!fbmResources) {
    return { fbmResources: [], total: 0 };
  }

  return {
    fbmResources,
    total: fetchAll ? response.data.length : response.data.meta.total,
  };
};

export const fetchParentResources = async (
  params = {}
): Promise<FbmResource[]> => {
  const response = await api.get(`/api/v4/fbm/resources`, {
    params: { 'q[s]': 'name asc', fetch_all: true, ...params },
  });

  return response.data.map((r) => normalizeFbmResource(r));
};

export const fetchFbmResource = async (id: Identifier) => {
  const response = await api.get(`/api/v4/fbm/resources/${id}`);
  return normalizeFbmResource(response.data);
};

export const createFbmResource = async (fbmResource: Partial<FbmResource>) => {
  const response = await api.post(`/api/v4/fbm/resources`, {
    fbm_resource: {
      name: fbmResource.name,
      description: fbmResource.description,
      location_id: fbmResource.locationId,
      parent_id: fbmResource.parentId,
      visit_description: fbmResource.visitDescription,
    },
  });
  return normalizeFbmResource(response.data);
};

export const updateFbmResource = async (fbmResource: Partial<FbmResource>) => {
  const response = await api.put(`/api/v4/fbm/resources/${fbmResource.id}`, {
    fbm_resource: {
      name: fbmResource.name,
      description: fbmResource.description,
      location_id: fbmResource.locationId,
      parent_id: fbmResource.parentId,
      visit_description: fbmResource.visitDescription,
    },
  });
  return normalizeFbmResource(response.data);
};

export const deleteFbmResource = async (fbmResource: Partial<FbmResource>) => {
  const response = await api.delete(`/api/v4/fbm/resources/${fbmResource.id}`);
  return normalizeFbmResource(response.data);
};
